export function calcTotalPrice(){
    // 1) get the selected variant
    const variantInput = document.querySelector('product-form-component input[name="id"][ref="variantId"]');
    // bundle
    let currentVariants = [];
    let currentVariant = {};
    if (variantInput.value.includes(',')) {
      // bundle product: split variant ids and append matching variants
      const ids = variantInput.value
        .split(',')
        .map(id => parseInt(id.trim(), 10))
        .filter(id => !Number.isNaN(id));

      if (typeof( bundle_building_variants)  !== undefined && Array.isArray(bundle_building_variants)) {
        ids.forEach(id => {
          const found = bundle_building_variants.find(v => v.id === id);
          if (found) currentVariants.push(found);
        });
      }
    }else{
      // normal product 
      const currentVariantId = (variantInput instanceof HTMLInputElement) ? parseInt(variantInput.value, 10) : null;
      if (currentVariantId && window.ShopifyAnalytics?.meta?.product?.variants) {
        currentVariant = window.ShopifyAnalytics.meta.product.variants.find(  v => v.id === currentVariantId );
      }
    }


    // 2) calculate the total price = variant price*quantity + warranty + product upsell
    let currentPrice = 0;

      // 2.1) add (variant price*quantity)  
      let variantQuantityInput = document.querySelector('product-form-component input[name="quantity"]');
      let quantity = 1;
      if (variantQuantityInput && variantQuantityInput instanceof HTMLInputElement) { quantity = parseInt(variantQuantityInput.value, 10); }
      if (Array.isArray(currentVariants) && currentVariants.length > 0) {
        const sumBundle = currentVariants.reduce((sum, v) => sum + (v?.price || 0), 0);
        currentPrice += (quantity * sumBundle);
      } else if (typeof currentVariant !== 'undefined' && currentVariant && currentVariant.price) {
        currentPrice += ( quantity * currentVariant.price );
      }

      // 2.2) add (warranty price)
      let warrantyPirce = 0;
      let selectedWarranty = document.querySelector("input[name='bed_warranty']:checked");
      if (selectedWarranty instanceof HTMLInputElement && selectedWarranty.dataset.price ) { currentPrice += Number(selectedWarranty.dataset.price); warrantyPirce=Number(selectedWarranty.dataset.price); }


      // 2.3) add (product upsell price)
      let productUpsell = document.querySelector(".product_upsell--added");
      if (productUpsell ) { 
        let upsellContainer = document.querySelector(".product-upsell__container");
        let upsellQuantity = 1;
        if (upsellContainer instanceof HTMLElement &&upsellContainer.dataset.upsellQuantity ) { upsellQuantity = Number(upsellContainer.dataset.upsellQuantity)}
        let upsellPrice = document.querySelector(".upsell_cta")?.dataset?.price || 0;    
        currentPrice += ( upsellQuantity * Number(upsellPrice) ) ; 
        // handle free 5 year warranty for split king bed
        if (upsellQuantity == 2) {currentPrice -= warrantyPirce; }
      }

      let productDetails = document.querySelector('.product-details');
      if (productDetails instanceof HTMLElement && productDetails.dataset.totalPrice ) {
        productDetails.dataset.totalPrice = String(currentPrice);
        let totalPriceSpan = productDetails.querySelector('.totalPrice');
        if (totalPriceSpan instanceof HTMLElement) { totalPriceSpan.innerHTML = `$${(currentPrice / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`; }
      }

  // show or hide finance options based on their limit 
  currentPrice = currentPrice / 100;
  document.querySelectorAll('.zip4').forEach( el => {
      if (!(el instanceof HTMLElement)) return;
      if (currentPrice > Number(el.dataset.limit) ) { el.classList.add('hidden'); }
      else { el.classList.remove('hidden'); }
  })

  // custom code for affirm
  var affirmLearnMore = document.getElementById("affirmLearnMore");
  // @ts-ignore
  if (affirmLearnMore && typeof affirm !== "undefined") {
    //Update the wrapper elements' attributes in the DOM
    affirmLearnMore.dataset.amount = String(currentPrice);
    affirm.ui.refresh();
    setTimeout(function () { affirm.ui.refresh(); }, 100);
  }
  // end affirm
}